import { apiFetch } from "../../api/client";
import { useAuthStore } from "../../store/authStore";

export function OrgSwitcher() {
  const me = useAuthStore((s) => s.me);
  const refreshMe = useAuthStore((s) => s.refreshMe);
  if (!me) return null;
  if (me.memberships.length <= 1) {
    return <span className="muted">{me.org.name}</span>;
  }
  return (
    <select
      aria-label="Organization"
      value={me.org.id}
      style={{ minHeight: 44, maxWidth: 160 }}
      onChange={async (e) => {
        await apiFetch("/api/v1/me/switch-org", {
          method: "POST",
          body: JSON.stringify({ orgId: e.target.value }),
        });
        await refreshMe();
        window.location.reload();
      }}
    >
      {me.memberships.map((m) => (
        <option key={m.orgId} value={m.orgId}>
          {m.orgName}
        </option>
      ))}
    </select>
  );
}
